import { useContext } from "react";
import { useSelector } from "react-redux";
import { Project, Identifiable, ProjectResource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  transferProjectResourceAllocations(
    request: Boundaries["transferProjectResourceAllocations"]["request"],
  ): void;
}

function useTransferProjectResourceAllocations(
  project: Identifiable<Project>,
  fromProjectResource: Identifiable<ProjectResource>,
  toProjectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isTransferProjectResourceAllocationsRequestPending(
        project,
        fromProjectResource,
        toProjectResource,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isTransferProjectResourceAllocationsRequestSuccess(
        project,
        fromProjectResource,
        toProjectResource,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isTransferProjectResourceAllocationsRequestFailure(
        project,
        fromProjectResource,
        toProjectResource,
      ),
    ),
    transferProjectResourceAllocations: core.transferProjectResourceAllocations,
  };
}

export { useTransferProjectResourceAllocations };
